<!-- TPOD-2263: centred loading overlay while a language switch applies (the
     zh-CN translation file is fetched over HTTP). Mirrors the auto-enrol overlay. -->
@if (isChangingLanguage) {
    <div class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 pointer-events-auto">
        <div class="bg-white rounded-lg px-6 py-5 shadow-lg flex flex-col items-center gap-3 min-w-[160px]">
            <mat-progress-spinner mode="indeterminate" [diameter]="40"></mat-progress-spinner>
            <span class="text-sm font-medium text-[#231F20]">{{ 'text.processing' | translate }}</span>
        </div>
    </div>
}

<header>
    <div class="max-width-container xl:px-[100px] md:px-[6.9%]">
        <div class="flex justify-between items-center md:px-0 px-6">
            <div
                class="left-panel lg:flex lg:items-center items-start"
                [ngClass]="[isAuthLayout ? 'w-1/5' : 'w-auto lg:w-3/5']">
                <div class="brand-logo-wrapper my-4">
                    <a [routerLink]="[isAuthLayout ? '/' : '/home']">
                        <img class="w-[5.3rem] md:w-[8rem]" src="./assets/images/brand_logo.png" alt="TaxPod-logo" />
                    </a>
                </div>
                <div *ngIf="!isAuthLayout && !isMobileView" class="lg:block hidden search-bar w-full mx-8 relative">
                    <div class="form-control-wrapper flex items-center">
                        <mat-icon
                            svgIcon="search"
                            class="absolute left-3 !w-4 text-[#004B65] cursor-pointer"
                            (click)="onSearch(searchInput.value)"></mat-icon>
                        <input
                            #searchInput
                            id="globalSearchBar"
                            type="text"
                            [attr.maxlength]="SEARCH_MAX_LENGTH"
                            class="form-control form-textbox !px-9 !h-11"
                            [placeholder]="'placeholder.defaultSearchExample' | translate"
                            (keydown.enter)="onSearch(searchInput.value)" />
                        <button
                            *ngIf="isSearchPopupVisible"
                            type="button"
                            class="flex items-center"
                            (click)="isSearchPopupVisible = false; onFilterClear()">
                            <mat-icon class="absolute right-3 text-[#a09d9d] !w-3" svgIcon="close"></mat-icon>
                        </button>
                    </div>

                    <div *ngIf="isSearchPopupVisible" #searchPopup class="absolute top-[calc(100%+0.5rem)] w-full">
                        <app-general-search-dropdown
                            (filterClearClicked)="onFilterClear()"
                            (suggestedKeywordClicked)="onSuggestedKeyword($event)"
                            (hotTopicClicked)="onHotTopicClicked()"></app-general-search-dropdown>
                    </div>
                </div>
            </div>
            <div class="right-panel lg:my-0 my-4" [ngClass]="[isAuthLayout ? 'w-4/5' : 'w-auto']">
                <div class="flex items-center justify-end">
                    <!-- isAskPodFeatureEnabled is the backend kill switch (SystemSetting
                         "Feature:AskPod:Web:Enabled"); it hides the entry point entirely. The
                         separate [disabled] binding below greys out a visible button mid-launch. -->
                    <button
                        *ngIf="!isAuthLayout && isAskPodFeatureEnabled"
                        type="button"
                        id="askPodLogoDesktop"
                        class="md:block hidden mr-7 flex-shrink-0 relative overflow-visible"
                        aria-label="askPOD"
                        [matTooltip]="'askPodPopup.tooltipTaxMadeEasy' | translate"
                        matTooltipPosition="above"
                        [disabled]="isAskpodLoading || isAskpodDisabled"
                        (click)="onAskPodClicked()">
                        <img
                            class="h-7 w-auto"
                            src="./assets/images/askpod-logo.svg"
                            alt="askPOD" />
                        <span class="askpod-new-badge">{{ 'askPodPopup.betaBadge' | translate }}</span>
                    </button>
                    <a
                        *ngIf="!isAuthLayout"
                        id="webinarScheduleNav"
                        class="md:mr-7 mr-4"
                        [routerLink]="['/program/schedule']">
                        <div class="bg-calendar-icon md:icon-[1.5rem] icon-[1.0rem]"></div>
                    </a>
                    <button
                        *ngIf="showLanguageDropdown"
                        type="button"
                        class="md:h-7 h-5 btn md:mr-7 mr-4 !px-0 flex-shrink-0"
                        [matMenuTriggerFor]="language">
                        <span class="inline-block md:icon-[1.5rem] icon-[1.0rem] bg-globe-icon mr-1"></span>
                        <span class="inline-block mr-1.5">
                            @if (selectedLanguage) {
                                {{ getLanguageTranslation(selectedLanguage.toLocaleLowerCase()) | translate }}
                            }
                        </span>
                        <span class="inline-block md:icon-[0.75rem] icon-[0.5rem] bg-arrow-down-icon"></span>
                    </button>
                    @if (isAuthLayout && isUserAuthenticated()) {
                        <button
                            type="button"
                            class="btn-outline md:text-base text-sm text-error !px-3 flex items-center"
                            (click)="logout()">
                            <span class="inline-block bg-logout-icon icon-[1.5rem] mr-1.5"></span>
                            {{ 'menu.logout' | translate }}
                        </button>
                    }
                    <a
                        *ngIf="showDemoButton"
                        class="btn-outline-tertiary md:text-base text-xs"
                        href="https://taxpod.com.my/book-a-demo/"
                        appAddTargetBlankNoOpener>
                        {{ 'button.bookADemo' | translate }}
                    </a>
                    <mat-menu #language="matMenu">
                        <button
                            *ngFor="let language of availableLanguage"
                            type="button"
                            mat-menu-item
                            (click)="changeSelectedLanguage(language.formattedLocal)">
                            @if (language.languageName) {
                                {{ getLanguageTranslation(language.formattedLocal.toLocaleLowerCase()) | translate }}
                            }
                        </button>
                    </mat-menu>
                    @if (!isAuthLayout) {
                        <div class="md:relative md:mr-7 mr-4">
                            <button
                                #notificationButton
                                id="notificationNav"
                                type="button"
                                class="flex items-center relative">
                                <span class="inline-block bg-bell-icon md:icon-[1.5rem] icon-[1.2rem]"></span>

                                <div
                                    class="count-notificaiton px-1 h-[1.125rem] font-bold rounded-full bg-red-500 absolute -right-[6px] -top-[4px] text-white flex items-center justify-center text-xs leading-none">
                                    {{ unreadNotificationCount }}
                                </div>
                            </button>

                            <div
                                #notification
                                class="z-50 w-full md:w-[30rem] absolute right-0 top-16 md:top-[2.5rem]"
                                [ngClass]="isToggleNotification ? 'block' : 'hidden'">
                                <app-notification
                                    [isNotificationOpen]="isNotificationOpen"
                                    (closeNotificationDropdown)="triggerNotification()"></app-notification>
                            </div>
                        </div>
                        <button
                            #menuTrigger="matMenuTrigger"
                            id="myProfileNav"
                            type="button"
                            class="flex items-center lg:mr-0 mr-4"
                            [matMenuTriggerFor]="profile">
                            <span class="inline-block bg-profile-icon md:icon-[1.5rem] icon-[1.2rem]"></span>
                        </button>
                        <mat-menu #profile="matMenu" xPosition="before">
                            <div class="px-5">
                                <p class="ellipsis-line-1 text-lg font-medium text-[#004B65]">
                                    {{ userDetails.fullName }}
                                </p>
                                <p class="text-[#7995A0] font-light text-base ellipsis-line-1">
                                    {{ userDetails.email }}
                                </p>
                            </div>

                            <div class="h-[1px] w-full my-3 bg-[#CFE8FF]"></div>

                            <div class="px-5 py-1 space-y-5">
                                <a
                                    *ngFor="let item of SIDE_MENU_ITEMS"
                                    class="flex items-center"
                                    [id]="item.id ? item.id : null"
                                    [routerLink]="item.link"
                                    (click)="isMobileView && closeMobileMenu(true)">
                                    <mat-icon class="flex-shrink-0" [svgIcon]="item.icon"></mat-icon>
                                    <span class="font-medium text-[1.125rem] ml-2">
                                        {{ item.title | translate }}
                                    </span>
                                </a>
                            </div>

                            <div class="h-[1px] w-full my-3 bg-[#CFE8FF]"></div>

                            <!-- TODO: Integrate Logout API -->
                            <button type="button" class="px-5 py-2 text-error flex items-center" (click)="logout()">
                                <span class="inline-block bg-logout-icon icon-[1.25rem]"></span>
                                <span class="font-medium text-[1.125rem] ml-2">
                                    {{ 'menu.logout' | translate }}
                                </span>
                            </button>
                        </mat-menu>
                        <button
                            type="button"
                            class="lg:hidden leading-none"
                            (click)="isMobileMenuOpen = !isMobileMenuOpen">
                            <mat-icon>{{ isMobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
                        </button>
                    }
                </div>
            </div>
        </div>
        <div *ngIf="!isAuthLayout && isMobileView" class="lg:hidden md:px-0 px-6 pb-4 flex items-center">
            <div class="search-bar w-full relative">
                <div class="form-control-wrapper flex items-center">
                    <mat-icon
                        svgIcon="search"
                        class="absolute left-3 !w-4 text-[#004B65] cursor-pointer"
                        (click)="onSearch(searchInputMobile.value)"></mat-icon>
                    <input
                        #searchInputMobile
                        id="globalSearchBar"
                        type="text"
                        [attr.maxlength]="SEARCH_MAX_LENGTH"
                        class="form-control form-textbox !px-8 !h-9"
                        [placeholder]="'placeholder.defaultSearchExample' | translate"
                        (keydown.enter)="onSearch(searchInputMobile.value)" />
                    <button
                        *ngIf="isSearchPopupVisible"
                        type="button"
                        class="flex items-center"
                        (click)="isSearchPopupVisible = false; onFilterClear()">
                        <mat-icon class="absolute right-3 text-[#a09d9d] !w-3" svgIcon="close"></mat-icon>
                    </button>
                </div>

                <div *ngIf="isSearchPopupVisible" #searchPopupMobile class="absolute top-[calc(100%+0.5rem)] w-full">
                    <app-general-search-dropdown
                        (filterClearClicked)="onFilterClear()"
                        (suggestedKeywordClicked)="onSuggestedKeyword($event)"
                        (hotTopicClicked)="onHotTopicClicked()"></app-general-search-dropdown>
                </div>
            </div>
            <!-- Same web flag as the desktop button: this is the web app's mobile breakpoint, not
                 the native app. The native app reads its own flag from the mobile API. -->
            <button
                *ngIf="isAskPodFeatureEnabled"
                type="button"
                id="askPodLogoMobile"
                class="ml-4 flex-shrink-0 md:hidden relative overflow-visible"
                aria-label="askPOD"
                [disabled]="isAskpodLoading || isAskpodDisabled"
                (click)="onAskPodClicked()">
                <img
                    class="h-6 w-auto"
                    src="./assets/images/askpod-logo.svg"
                    alt="askPOD" />
                <span class="askpod-new-badge">{{ 'askPodPopup.betaBadge' | translate }}</span>
            </button>
        </div>
        <div class="mobile-menu-container" [ngClass]="{ open: isMobileMenuOpen }">
            @if (!isAuthLayout) {
                <app-mobile-navbar (closeMobileMenu)="closeMobileMenu($event)"></app-mobile-navbar>
            }
        </div>
    </div>
</header>
